import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Loading from "./../../../assets/svg/loading.svg";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
let Model = (props) => {
  return (
    <BootstrapDialog
      onClose={props.onClose}
      aria-labelledby="customized-dialog-title"
      open={props.open}
      maxWidth={props.width === "md" ? "md" : "lg"}
      fullWidth
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={props.onClose}
      >
        <p className="model-heading">{props.modelTitle}</p>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          {props.children}
          {!props.buttonHide && (
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={3} lg={3} md={3} sm={2} xs={2}></Grid>
                <Grid item xl={6} lg={6} md={6} sm={8} xs={8}>
                  <Button
                    className="form-button"
                    variant="text"
                    onClick={props.buttonHandler}
                    disabled={props.loading}
                  >
                    {props.loading ? <img src={Loading} /> : props.buttonTitle}
                  </Button>
                </Grid>
                <Grid item xl={3} lg={3} md={3} sm={2} xs={2}></Grid>
              </Grid>
            </Box>
          )}
        </Typography>
      </DialogContent>
    </BootstrapDialog>
  );
};
export default Model;
